import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppLayoutComponent } from './layout/layout.component';
import { ErrorComponent } from './shared/components/error/error.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { AuthGuard } from './core/services/auth.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: AppLayoutComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
      },
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule)
      },
      {
        path: 'companies',
        loadChildren: () => import('./features/companies/companies.module').then(m => m.CompaniesModule)
      },
      {
        path: 'projects',
        loadChildren: () => import('./features/sites/sites.module').then(m => m.SitesModule)
      },
      {
        path: 'projects/:id/status',
        loadChildren: () => import('./features/site-status/site-status.module').then(m => m.SiteStatusModule)
      },
      {
        path: 'projects/:id/companiesStats',
        loadChildren: () => import('./features/site-companies-stats/site-companies-stats.module').then(m => m.SiteCompaniesStatsModule)
      },
      {
      path: 'projects/:id/movementsLog',
        loadChildren: () => import('./features/site-movements-log/site-movements-log.module').then(m => m.SiteMovementsLogModule)
      },
      {
        path: 'companies/:id/employeesStats',
        loadChildren: () => import(
          './features/company-employees-stats/company-employees-stats.module'
          ).then(m => m.CompanyEmployeesStatsModule)
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.module').then(m => m.UsersModule)
      },
      {
        path: 'users/:id/edit',
        loadChildren: () => import('./features/edit-users/edit-users.module').then(m => m.EditUsersModule),
      }
      // {
      //   path: 'dashboard',
      //   loadChildren: () => import('./demo/dashboard/dashboard.module').then(m => m.DashboardModule)
      // },
      // {
      //   path: 'material',
      //   loadChildren: () => import('./demo/material-component/material.module').then(m => m.MaterialComponentsModule)
      // },
      // {
      //   path: 'apps',
      //   loadChildren: () => import('./demo/apps/apps.module').then(m => m.AppsModule)
      // },
      // {
      //   path: 'forms',
      //   loadChildren: () => import('./demo/forms/forms.module').then(m => m.FormModule)
      // },
      // {
      //   path: 'tables',
      //   loadChildren: () => import('./demo/tables/tables.module').then(m => m.TablesModule)
      // },
      // {
      //   path: 'datatables',
      //   loadChildren: () => import('./demo/datatables/datatables.module').then(m => m.DataTablesModule)
      // },
      // {
      //   path: 'pages',
      //   loadChildren: () => import('./demo/pages/pages.module').then(m => m.PagesModule)
      // },
      // {
      //   path: 'widgets',
      //   loadChildren: () => import('./demo/widgets/widgets.module').then(m => m.WidgetsModule)
      // },
      // {
      //   path: 'charts',
      //   loadChildren: () => import('./demo/charts/chartslib.module').then(m => m.ChartslibModule)
      // },
      // {
      //   path: 'multi',
      //   loadChildren: () => import('./demo/multi-dropdown/multi-dd.module').then(m => m.MultiModule)
      // }
    ]
  },
  {
    path: 'authentication',
    loadChildren: () => import('./authentication/authentication.module').then(m => m.AuthenticationModule)
  },
  {
    path: 'mobile-start',
    loadChildren: () => import('./mobile-start/mobile-start.module').then(m => m.MobileStartModule)
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: '404',
    component: NotFoundComponent
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
